import { useLingui } from '@lingui/react/macro'
import { Skeleton } from '@/components/ui/skeleton'
import { ButtonSkeleton } from '@/components/custom/dialog-skeleton'
import { DescribeGridSkeleton } from '../offers/describe-dialog-pending'

/** The org's name over the group's, as every page of the public group survey heads itself. */
function GroupHeaderSkeleton() {
  return (
    <div className="flex flex-col items-center gap-1">
      <Skeleton className="h-7 w-14" />
      <Skeleton className="h-6 w-20" />
    </div>
  )
}

export function GroupLoginPending() {
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <GroupHeaderSkeleton />
    </div>
  )
}

/**
 * The survey's layout (the client's logo over the page) while its chunk loads. A link into the survey lands on the
 * group's login, so that is the page drawn under the logo.
 */
export function GroupSurveyPending() {
  return (
    <div className="flex flex-col items-center gap-10">
      <Skeleton className="mx-auto h-28 w-full max-w-sm" />
      <GroupLoginPending />
    </div>
  )
}

/**
 * One step of the survey (DescribeProfile with its title): the step's heading and instructions, the grid, and the
 * step's buttons. Also the step page's own fallback while the participant's saved answers load.
 */
export function GroupDescribeStepSkeleton() {
  const { t } = useLingui()
  return (
    <section className="flex w-full flex-col items-center gap-4">
      <div className="w-full">
        <div className="flex h-7 items-center">
          <Skeleton className="h-5 w-80 max-w-full" />
        </div>
        {/* Centred, as the page sets its text. */}
        <div className="mt-1 flex flex-col text-sm leading-relaxed">
          {['h-4 w-full', 'h-4 w-11/12', 'h-4 w-2/3'].map((line) => (
            <span key={line} className="flex h-[1lh] items-center justify-center">
              <Skeleton className={line} />
            </span>
          ))}
        </div>
      </div>
      <DescribeGridSkeleton dimensions={false} />
      <div className="flex gap-3">
        <ButtonSkeleton label={t`Next`} iconEnd />
      </div>
    </section>
  )
}

export function GroupDescribeStepPending() {
  return (
    <section className="flex w-full max-w-5xl flex-col items-center gap-6 px-6 pb-6 text-center">
      <GroupHeaderSkeleton />
      <GroupDescribeStepSkeleton />
    </section>
  )
}
